var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"page":_vm.page,"cartCount":_vm.cartCount}}),_c('Bar'),_c('router-view',{on:{"page":_vm.getPage}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }